// src/utils/format.ts

// adjust these types if yours differ
type Client = { id: string; name: string };
type ProjectLike = { id: string; clientId?: string; address?: string };

export function projectDisplayLabelPretty(
  project: ProjectLike,
  clients: Client[]
) {
  const clientName =
    clients.find((c) => c.id === project.clientId)?.name || "Unknown Client";

  const parts = [
    project.id,
    clientName,
    (project.address || "").trim(),
  ].filter(Boolean);

  return parts.join(" | "); // ✅ compact separator
}


// ...existing exports, including projectDisplayLabelPretty

export function subContractDisplayLabelPretty(
  sc: { id?: string; projectId?: string; subContractorId?: string; title?: string } | null | undefined,
  projects: any[] = [],
  clients: any[] = [],
  subcontractors: Array<{ id: string; name: string }> = []
) {
  if (!sc) return "—";

  const contractorName =
    subcontractors.find((x) => x.id === (sc.subContractorId || ""))?.name ||
    sc.subContractorId ||
    "Subcontractor";

  const title = (sc.title || "").trim() || "Untitled";

  const p = projects.find((x: any) => x.id === (sc.projectId || ""));
  const projectPretty = p ? projectDisplayLabelPretty(p, clients) : sc.projectId || "Project";

  return `${contractorName} | ${title} | ${projectPretty}`;
}
